import { IDmMucHocPhiTinChiCopyRequest } from "../../model/request/category/dmMucHocPhiTinChiCopyRequest";
import { IDmMucHocPhiTinChiViewModelRequest } from "../../model/request/category/dmMucHocPhiTinChiViewModelRequest";
import { apiClient } from "../apiClient";
import { IDmMucHocPhiTinChi } from "./../../model/respone/category/IDmMucHocPhiTinChi";
export const MUC_HOC_PHI_TIN_CHI_ENDPOINT = "muc-hoc-phi-tin-chi";
export const mucHocPhiTinChiApi = {
  Select: (payload: IDmMucHocPhiTinChiViewModelRequest) =>
    apiClient.post(`${MUC_HOC_PHI_TIN_CHI_ENDPOINT}/select-data`, payload),

  Save: (payload: IDmMucHocPhiTinChi[]) =>
    apiClient.post(`${MUC_HOC_PHI_TIN_CHI_ENDPOINT}/save-data`, payload),

  Lock: (payload: IDmMucHocPhiTinChiViewModelRequest) =>
    apiClient.post(
      `${MUC_HOC_PHI_TIN_CHI_ENDPOINT}/true/lock-or-unlock`,
      payload
    ),

  Unlock: (payload: IDmMucHocPhiTinChiViewModelRequest) =>
    apiClient.post(
      `${MUC_HOC_PHI_TIN_CHI_ENDPOINT}/false/lock-or-unlock`,
      payload
    ),
  Copy: (payload: IDmMucHocPhiTinChiCopyRequest) =>
    apiClient.post(`${MUC_HOC_PHI_TIN_CHI_ENDPOINT}/copy`, payload),
};
